import { sortArray } from '@nu-art/ts-common';
import { SnapshotEventType } from './types.js';
/**
 * returns true if the encounter event is a snapshot event.
 */
export const isSnapshotEvent = (event) => event.eventType === SnapshotEventType;
/**
 * Returns only encounter events that are not snapshot events (order, bug-report, pathway, finding, end-encounter).
 */
export const filterNonSnapshotEvents = (events) => (events.filter((e) => !isSnapshotEvent(e)));
/**
 * Latest snapshot at or before the given display event's {@link DB_EncounterEvent.assignedTimestamp}.
 * Used to decide which simulations belong to a display-event row and which snapshotId to use when creating a simulation.
 *
 * @param allEncounterEvents - All events for the same encounter (must include snapshot events)
 * @param event - The display event (non–snapshot-event) to match
 * @returns The snapshot with largest `assignedTimestamp` among those ≤ the display event's `assignedTimestamp`, or null
 */
export const getLatestSnapshotAtOrBeforeEventTime = (allEncounterEvents, event) => {
    const eventTime = event.assignedTimestamp ?? 0;
    const snapshotEvents = sortArray(allEncounterEvents
        .filter(isSnapshotEvent)
        .filter((e) => (e.assignedTimestamp ?? 0) <= eventTime), (e) => e.assignedTimestamp ?? 0, true);
    return snapshotEvents.length > 0 ? snapshotEvents[0] : null;
};
//# sourceMappingURL=utils.js.map